import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import parameters from '../../config/parameters';
import configs from '../../config/config';
import Avatar from "./Avatar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const getPlayerBalance = player => {
    try {
        const wallet = player.wallets[0];
        return !!wallet ? wallet.balance : undefined;
    } catch (e) {
        console.log('exception on getting player wallet: ', e);
    }
}
const PlayerTab = ({ player, avatar, type, onChange, selected }) => {
    const { t } = useTranslation();
    const playerBalance = getPlayerBalance(player);

    const onChangeCallback = useCallback(e => {
        if (onChange) onChange(player._id, !e.target.checked);
    }, [player, onChange]);

    return (
        <div className={`playerTab`}>
            <div className={`avatarContainer`}>
                <Avatar data={avatar} />
                <div className={`roleContainer ${player.isOwner ? 'owner' : `${parameters.accountTypeIds[player.typeId]}`}`}>
                    <p className={``}></p>
                </div>
            </div>
            <div className={`clubInfo`}>
                <span className={`clubName`}>{player.username}</span>
                <p className={`id`}>{t('id')}: {player.globalAccountId}</p>
                {type === 'tradeRecord' ?
                    <span className={`nickname`}>{t(player.direction)}: </span> :
                    <span className={`nickname`}>{t('nickname')}: <span>{player.nickname}</span></span>
                }
            </div>
            {playerBalance !== undefined ?
                <div className={`clubBalance`}>
                    {type === "trade" &&
                        <React.Fragment>
                            <span className={`chipIcon`}></span>
                            <span className={`balanceNumber`}>{playerBalance}</span>
                        </React.Fragment>
                    }
                    {type === "tradeRecord" &&
                        <React.Fragment>
                            <div className={`transferAmount`}>
                                <span className={`balanceNumber`}>{player.amount}</span>
                                <span className={`${player.type}Icon`}></span>
                            </div>
                            <div className={`transaction`}>
                                <span>{t(player.direction)}</span>
                                <p>{player.date}</p>
                            </div>
                        </React.Fragment>
                    }
                    {type !== "tradeRecord" &&
                        <label className="checkboxContainer">
                            <input type="checkbox" onChange={onChangeCallback} checked={selected} />
                            <span className="checkmark"></span>
                        </label>
                    }
                </div> :
                <div className={`clubBalance`}>
                    <FontAwesomeIcon icon={faExclamationTriangle} color="red"> </FontAwesomeIcon>
                </div>
            }

        </div>
    );
};

export default PlayerTab;
